import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';

interface LogoutConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const LogoutConfirmDialog: React.FC<LogoutConfirmDialogProps> = ({ open, onOpenChange, onConfirm }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent id="logout_dialog_content" className="max-w-md">
        <DialogHeader>
          <DialogTitle id="logout_dialog_title" className="flex items-center gap-2">
            <LogOut className="h-5 w-5 text-red-500" />
            Confirm Logout
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 text-center">
          <p id="logout_dialog_message">Are you sure you want to log out?</p>
        </div>
        <div className="flex justify-end gap-2">
          <Button id="logout_dialog_cancel_btn" variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button id="logout_dialog_confirm_btn" variant="destructive" onClick={onConfirm}>
            Logout
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmDialog;
